// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__3nDFA","title":"ClientCherryInfo_title__1zmWS","itemText":"ClientCherryInfo_itemText__29r5M"};